import {iso6391ToIso6392, iso6392ToIso6391} from "../../../../utils/helpers"

export default {
	data: function () {
		return {
			entityName: 'message_template',
			moduleName: 'messageTemplates',
			detailPageRouteName: 'messageTemplateDetail',
			entity: {
				name: null,
				type: 'info',
				force_confirmation: false,
				timer: null,
				time_validity: null,
				translations: {},
				id_operator: null
			},
			isGlobal: false,
			updateFields: [
				'name',
				'type',
				'force_confirmation',
				'timer',
				'translations',
				'time_validity',
				'id_operator'
			],
			datetimeFields: [
				'time_validity',
			],
			selectedLanguageId: this.$language.current,
			translation: {
				language: this.$language.current,
				subject: '',
				short_body: '',
				body: ''
			}
		}
	},
	watch: {},
	computed: {
		isGlobalComputed: {
			get() {
				return this.entity.id_operator === null
			},
			set(newValue) {
				if (newValue) {
					this.entity.id_operator = null
				} else {
					this.getOperatorsAndSetIdOperatorToEntity()
				}
			}
		},
		operatorIdComputed: {
			get() {
				return this.entity.id_operator
			},
			set(newValue) {
				this.entity.id_operator = newValue
			}
		}
	},
	methods: {
		_beforeCreateEntityActions(params = null) {
			let translations = this.prepareTranslationsForEntityActions(params)

			let data = {
				name: params.name,
				type: params.type,
				force_confirmation: params.force_confirmation,
				timer: (isNaN(parseInt(params.timer))) ? null : params.timer,
				time_validity: params.time_validity,
				id_operator: params.id_operator,
				translations: translations,
			}

			return data
		},
		_beforeUpdateEntityActions(params = null) {
			let translations = this.prepareTranslationsForEntityActions(params)

			let data = {
				name: params.name,
				type: params.type,
				force_confirmation: params.force_confirmation,
				timer: (isNaN(parseInt(params.timer))) ? null : params.timer,
				time_validity: params.time_validity,
				translations: translations,
			}

			return data
		},
		prepareTranslationsForEntityActions(params = null) {
			let translations = {}
			for (const key in params.translations) {
				let translation = params.translations[key]
				let lang = iso6391ToIso6392(key)
				translations[lang] = {
					"subject": translation.subject,
					"short_body": translation.short_body,
					"body": translation.body
				}
			}
			return translations
		},
		_processDetailErrorMessage(error) {
			return this.processErrorMessage(error)
		},
		_afterGetEntityActions() {
			let translations = {}
			for (const key in this.entity.translations) {
				let translation = this.entity.translations[key]
				let lang = iso6392ToIso6391(key)
				translations[lang] = {
					"subject": translation.subject,
					"short_body": translation.short_body,
					"body": translation.body
				}
			}
			this.entity.translations = translations
			this.emptyMessage()
		},
		processErrorMessage(error) {
			let nameError = null
			let translationError = null
			let languageError = null
			let subjectError = null
			let shortBodyError = null

			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, 'Message\'s name is missing.')) {
					nameError = this.$gettext('Zadejte název')
				}
				if (this._.includes(errorMessage, 'Message translation\'s Subject is missing.')) {
					translationError = this.$gettext('Vyplňte všechny překlady.')
				}
				if (this._.includes(errorMessage, 'You have to fill either translation.body or translation.short_body')) {
					translationError = this.$gettext('Vyplňte alespoň tělo, nebo krátké tělo oznámení.')
				}
				if (this._.includes(errorMessage, 'Message translation is empty.')) {
					languageError = this.$gettext('Zvolte alespoň jeden jazyk překladu.')
				}
				if (this._.includes(errorMessage, 'Message translation\'s Subject is too long - 255 letters at most are alowed.')) {
					subjectError = this.$gettext('Povolená délka je maximálně 255 znaků.')
				}
				if (this._.includes(errorMessage, 'Message translation\'s Short body is too long - 255 letters at most are alowed.')) {
					shortBodyError = this.$gettext('Povolená délka je maximálně 255 znaků.')
				}
			}.bind(this))

			if (nameError !== null) {
				this.$refs['messagetemplatebasicref'].$refs['templatenameref'].setForcedInvalid(true, nameError)
			} else {
				this.$refs['messagetemplatebasicref'].$refs['templatenameref'].setForcedInvalid()
			}

			if (subjectError !== null) {
				this.$refs['messagetemplatebasicref'].$refs['translationsubjectref'].setForcedInvalid(true, subjectError)
			} else {
				this.$refs['messagetemplatebasicref'].$refs['translationsubjectref'].setForcedInvalid()
			}

			if (shortBodyError !== null) {
				this.$refs['messagetemplatebasicref'].$refs['translationshortbodyref'].setForcedInvalid(true, shortBodyError)
			} else {
				this.$refs['messagetemplatebasicref'].$refs['translationshortbodyref'].setForcedInvalid()
			}

			if (translationError !== null) {
				return translationError
			}

			if (languageError !== null) {
				return languageError
			}

			return error['error_message']
		},
		reset() {
			this.$refs['messagetemplatebasicref'].$refs['templatenameref'].setForcedInvalid()
			this.$refs['messagetemplatebasicref'].$refs['translationsubjectref'].setForcedInvalid()
			this.$refs['messagetemplatebasicref'].$refs['translationshortbodyref'].setForcedInvalid()
			this.$refs['messagetemplatebasicref'].$refs['translationbodyref'].setForcedInvalid()
		},
		_afterUpdateEntityActions() {
			this.reset()
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/messagetemplates/mixins/messageTemplates.js